import { render, staticRenderFns } from "./WhatWeDoBest.vue?vue&type=template&id=6f83344c&scoped=true"
import script from "./WhatWeDoBest.vue?vue&type=script&lang=js"
export * from "./WhatWeDoBest.vue?vue&type=script&lang=js"
import style0 from "./WhatWeDoBest.vue?vue&type=style&index=0&id=6f83344c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f83344c",
  null
  
)

export default component.exports